import { render } from "./CallIcon2.vue?vue&type=template&id=0e1b325a"
import script from "./CallIcon2.vue?vue&type=script&lang=js"
export * from "./CallIcon2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__